<div class="body">
  <h2>{{content?.sectionTitle || 'AGENT CERTIFICATION NOTIFICATION'}}</h2>
  <!-- possible edit button-->

  <form [formGroup]="entitlementsInfoForm">
    <div class="drop-downs">
      <!-- LINE OF BUSINESS -->
      <mat-form-field appearance="outline">
        <mat-label>Line Of Business</mat-label>
        <mat-select aria-label="Line Of Business" formControlName="lineOfBusiness">
          @for (lob of availableLinesOfBusiness; track lob) {
            <mat-option [value]="lob">{{lob}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- REGION -->
      <mat-form-field appearance="outline">
        <mat-label>Region</mat-label>
        <mat-select aria-label="Region" formControlName="region">
          @for (region of availableRegions; track region) {
            <mat-option [value]="region">{{region}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- AGENCIES -->
      <mat-form-field class="agency-field" appearance="outline">
        <mat-label>Agency</mat-label>
        <mat-select aria-label="Agency" formControlName="agency" [compareWith]="trackAgencyComparison">
          @for (agency of availableAgencies | NoSuperAgencyForInternalUser:user.basicUserInfo.userType; track agency) {
            <mat-option [value]="agency">
              {{agency.agencyName}} - {{agency.region}} - {{ agency.agencyId}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </form>

  @if (formValuesAsJson.agency) {
    <div id="npn">
      <span><strong>NPN:</strong> {{npn}}</span>
    </div>
    @if (!isMinnesotaRegionSelected) {
      <div id="ffmId">
        <span><strong>FFM ID:</strong> {{ffmId}}</span>
      </div>
      <button mat-raised-button color="primary" (click)="editFFMInfo(npn, ffmId)">Edit FFM Information</button>
      <div id="role" style="margin-top: 15px;">
        <span><strong>User Role:</strong> {{userType}}</span>
      </div>
      <div>
        <strong>Certifications: </strong>
        @if (validCertifications && validCertifications.length > 0) {
          <ul>
            @for (c of validCertifications; track c) {
              <li>{{c.name}} ({{c.startDate}} to {{c.endDate}})</li>
            }
          </ul>
        } @else {
          No valid certifications for selected agency.
        }
      </div>
    }
    <div>
      <strong>Entitlements: </strong>
      @if (activeEntitlements && activeEntitlements.length > 0) {
        <ul>
          @for (e of activeEntitlements; track e) {
            <li>{{e.description}}</li>
          }
        </ul>
      } @else {
        No Entitlements for selected agency.
      }
    </div>
  }


</div>
